export default __webpack_public_path__ + "static/media/navigation-menu-closed.67e8805d.svg";